import { format } from 'date-fns';

import usePackageSummary from '../../../hooks/api/packages/usePackageSummary';
import { prettyNumber } from '../../../../shared/utils/numbers';
import Loader from '../../generic/Loader';
import Tooltip from '../../generic/Tooltip';

import styles from './PackageCount.module.less';

/**
 * Component to show the total package count.
 * On hover, a tooltip displays the last cache date.
 */
const PackageCount = () => {
  const { data, isLoading } = usePackageSummary();
  const count = data ? prettyNumber(data.count) : 'N/A';
  const lastCacheDate = data?.lastCacheDate
    ? format(new Date(data.lastCacheDate), 'MMMM do yyyy, h:mm:ss aaa')
    : null;
  const packageCountContent = isLoading ? (
    <div className="margin-top-sm">
      <Loader size={30} />
    </div>
  ) : (
    <div className={styles.count}>{count}</div>
  );

  return (
    <Tooltip id="last-cache-date" tooltip={lastCacheDate}>
      <div className={styles.container}>
        <div className={styles.label}>Packages</div>
        {packageCountContent}
      </div>
    </Tooltip>
  );
};

export default PackageCount;
